import { OnboardingProgressWithAccountTypeModel } from '@/api/models/propertyManager';
import { OnboardingRoutes, PMPRoutes, Routes } from '@/config/routes';

type LocationDescriptor = string;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type RouteState = any;

const addCampaignToUrl = (url: string, campaign?: string | null): string => {
  if (!campaign) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}campaign=${campaign}`;
};

export const getCurrentOnboardingStep = (
  onboardingProgress: OnboardingProgressWithAccountTypeModel,
  campaign?: string | null
): [LocationDescriptor, RouteState?] => 
  // All users are property managers now, redirect directly to dashboard
  // Users can create property locations from the dashboard if needed
  [addCampaignToUrl(PMPRoutes.dashboard, campaign)]
;

export const getNextOnboardingStep = (
  currentStep: Routes,
  onboardingProgress: OnboardingProgressWithAccountTypeModel,
  campaign?: string | null
): [LocationDescriptor, RouteState?] => {
  // All users are property managers now
  if (currentStep === OnboardingRoutes.propertyLocationCreate) {
    return [addCampaignToUrl(PMPRoutes.onboardingChecklist, campaign)];
  }

  // Always redirect to dashboard - users can manage properties from there
  return [addCampaignToUrl(PMPRoutes.dashboard, campaign)];
};
